<template>
  <CContainer>
    <CRow class="justify-content-evenly">
      <CCol lg="6">
        <div id="category-view" ref="powerCurveView">

          <div class="category-form">

            <div class="fixed">
              <transition name="fade">
                <div class="alert alert-success" role="alert" v-if="success">
                  <span style="font-style: italic; font-weight: bold">{{ alertPlaceholder }}</span> added successfully!
                </div>
              </transition>
              <transition name="fade">
                <div class="alert alert-info" role="alert" v-if="updateSuccess">
                  <span style="font-style: italic; font-weight: bold">{{ alertPlaceholder }}</span> updated successfully!
                </div>
              </transition>
              <transition name="">
                <div class="alert alert-danger" role="alert" v-if="deleteSuccess">
                  <span style="font-style: italic; font-weight: bold">{{ modalProps['modalName'] }}</span> deleted successfully!
                </div>
              </transition>
            </div>

            <CCard class="">

              <CCardHeader align="center">
                <strong>Power Curve Form</strong>
              </CCardHeader>

              <div style="padding: 2% 2%">
                <CRow>
                  <CCol sm="12">
                    <CInput
                        id="projectName"
                        name="projectName"
                        v-model="projectName"
                        label="Project Name"
                        placeholder="Enter new project name"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CInput
                        type="number"
                        v-model="time_weeks"
                        label="Time"
                        placeholder="Weeks"
                    />
                  </CCol>
                  <CCol>
                    <CInput
                        type="number"
                        v-model="currency"
                        label="Currency"
                        placeholder="Total cash"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <label>Impedance (&ohm;)</label>
                </CRow>
                <vue-slider class="my-3 custom-class"
                  v-model="slider"
                  :data="sliderData"
                  :process-style="{background: 
                    slider > 0 && slider <= 10 ? '#66ff00':
                    slider > 10 && slider <= 100 ? '#a1ff62':
                    slider > 100 && slider <= 1000 ? '#bfff95':
                    slider > 1000 && slider <= 10000 ? '#e8cccc':
                    slider > 10000 && slider <= 100000? '#bc6b6b':'#8b0000'}"
                ></vue-slider>

                <!-- button -->
                <CRow>
                  <CCol align="right" sm="12" style="margin-top: 20px">
                    <CButton :disabled="!isFormFilled(true)" @click="resetForm" style="margin: 0 32px" type="button"
                             class="btn btn-danger">Reset
                    </CButton>
                    <CButton :hidden="!newItem" :disabled="!isFormFilled()" @click="calculatePower" type="button" class="btn btn-primary">Add
                    </CButton>
                    <CButton :hidden="newItem" :disabled="!isFormFilled()" @click="updatePowerCurve" type="button" class="btn btn-primary">Update
                    </CButton>
                  </CCol>
                </CRow>

              </div>

            </CCard>
          </div>

          <div class="category-form">
            <CCard class="">

              <CCardHeader align="center">
                <strong>Power Curve List</strong>
              </CCardHeader>

              <AdvancedTables
                :key="advancedTableKey"
                @viewQuestionClicked="setID"
                @toggle="setToggle"
                :table-headers="[
                  'name',
                  'tension',
                  'power',
                ]"
                :json-data="projects"
              >
                <CCardBody style="background-color: #ebedef;">
                  <div style="display: grid" class="container">
                    <div :hidden="deleting"></div>

                    <div :hidden="deleting">
                      <CButton size="sm" class="btn btn-primary update-btn" @click="sendToUpdate(false)">
                        Update
                      </CButton>
                    </div>

                    <div class="last-item">
                      <CButton size="sm" class="btn btn-danger" @click="sendToUpdate(true); modalProps['showModal'] = true;">
                        Delete
                      </CButton>

                      <CModal
                          title="Are you sure?"
                          color="danger"
                          :show.sync="modalProps['showModal']"
                      >
                        You are about to delete
                        <span style="font-weight: bold; font-style: italic">{{ modalProps['modalName'] }}.</span>
                        Are you sure?

                        <template v-slot:footer>
                          <CButton type="button" class="btn btn-secondary" @click="modalProps['showModal'] = false">
                            Cancel
                          </CButton>
                          <CButton type="button" class="btn btn-danger" @click="deletePowerCurve">
                            Delete
                          </CButton>
                        </template>
                      </CModal>

                    </div>
                  </div>
                </CCardBody>
              </AdvancedTables>

            </CCard>
          </div>

        </div>
      </CCol>
      <CCol lg="6">
        <div>
          <CCard class="">
            <CCardHeader align="center">
              <strong>Power Curve Graph</strong>
            </CCardHeader>

            <div style="padding: 2% 2%">
              <CChartLine
                  class="power-curve-graph"
                  :datasets="finalData"
                  :labels="graphLabel"
                  :options="{
                    maintainAspectRatio: false,
                    scales: {
                      xAxes: [{
                        display: true,
                        ticks: {
                          callback: function(value) {
                              return value.substr(0, 10);//truncate label
                          },
                        }
                      }],
                      yAxes: [{
                        display: true,
                        type: 'logarithmic',
                        ticks: {
                          maxTicksLimit: 8,
                          callback: function(value) {
                              return value.toExponential(0)
                          },
                        }
                      }]
                    }
                  }"
              />
            </div>
          </CCard>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import AdvancedTables from "@/views/table/AdvancedTables";
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import axios from "axios";
import { CChartLine } from '@coreui/vue-chartjs'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "PowerCurve",
  components: {
    AdvancedTables,
    VueRangeSlider,
    CChartLine,
    VueSlider
  },
  data() {
    return {
      alertPlaceholder: "",
      success: false,
      updateSuccess: false,
      deleteSuccess: false,
      modal: false,
      modalProps: {
        showModal: false,
        modalName: "",
      },
      wasSelected: "",
      selected: "",
      newItem: true,
      deleting: false,
      result: [],
      advancedTableKey: 0,
      toggle: false,
      questionUpdateInProgress: false,

      //for power curve
      projectName: "",
      time_weeks: "",
      currency: "",
      width: '100%',
      height: 12,
      max: 1,
      min: 1,
      value: 0,
      showSlider: false,
      projects: [],
      displayProjects: false,

      //for power curve
      graphResult: [],
      graphData: [],
      graphValue: {
        label: [],
        backgroundColor: [],
        borderColor: [],
        pointBackgroundColor: [],
        pointBorderColor: '#fff',
        data: []
      },
      graphLabel: [],
      powerData: [],
      impedanceData: [],
      currencyData: [],
      tensionData: [],
      finalData: [],
      selectedImpedance: 'impedanceBtn1',

      slider:'1',
      // sliderData: [1, 10, 100, 1000, 10000, 100000, 1000000],
      sliderData: {
          '1': '1',
          '10': '10',
          '100': '100',
          '1000': '1k',
          '10000': '10k',
          '100000': '100k',
          '1000000': '1M',
      },
      themeColor: '#FF0000'
    }
  },
  created : function() {
    VueRangeSlider.methods.handleKeyup = ()=> console.log;
    VueRangeSlider.methods.handleKeydown = ()=> console.log;
  },
  mounted() {
    this.getData();
  },
  methods: {
    setID(id) {
      console.log('setID')
      let self = this
      self.selected = id
    },

    setToggle(value) {
      let self = this
      self.toggle = value
      console.log('toggle', self.toggle)
      self.result = []
    },

    resetForm() {
      let self = this
      console.log('resetForm')

      self.projectName = "";
      self.time_weeks = "";
      self.currency = "";
      self.slider = '1'
      self.newItem = true
      self.showSlider = false

      this.graphLabel = []
      this.impedanceData = []
      this.powerData = []
      this.tensionData = []
      this.currencyData = []

    },

    isFormFilled(resetButtonOnly = false) {
      let self = this
      console.log('is form filled')
      if (resetButtonOnly) {
        return (self.projectName !== "") || (self.time_weeks !== "") || (self.currency !== "") || (self.slider > 0);
      }
      return (self.projectName !== "") && (self.time_weeks !== "") && (self.currency !== "") && (self.slider > 0);
    },

    calculatePower() {
      let self = this;
      const token = localStorage.getItem("api_token")
      const company_id = localStorage.getItem("company_id")

      const postData = {
        name: self.projectName,
        time_weeks: self.time_weeks,
        impedance: self.slider,
        currency: self.currency,
        company_id: company_id
      };
      axios.post(this.$apiAdress + '/api/projects', postData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      });

      this.alertPlaceholder = this.projectName;
      this.success = true;

      this.resetForm();

      setTimeout(function () {
        this.success = !this.success
      }.bind(this), 10000);
      // self.reset()
      this.forceRerender()
    },

    getData() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/projects', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('power curve', response.data.data)
        self.projects = response.data.data
        self.projects.forEach(function(part, index) {
          this[index].power = this[index].power.toExponential(4)
          this[index].tension = this[index].tension.toExponential(4)
        }, self.projects)
        self.graphResult = response.data.data
        self.getStat()
      }).catch(function (error) {
        console.log(error);
      });
    },

    getStat() {
      let self = this;
      self.graphResult.forEach((project) => {
        self.graphLabel.push(project.name)
        self.powerData.push(project.power)
        self.tensionData.push(project.tension)
        self.currencyData.push(project.currency)
        self.impedanceData.push(project.impedance)
      })

      self.finalData = [
        {
          label: 'Impedance',
          backgroundColor: 'rgba(134, 134, 245, 0.2)',
          borderColor: 'rgba(134, 134, 245, 1)',
          pointBackgroundColor: 'rgba(134, 134, 245, 1)',
          pointBorderColor: '#fff',
          data: self.impedanceData,
          fill:false
        },
        {
          label: 'Currency',
          backgroundColor: 'rgba(231, 178, 88, 0.2)',
          borderColor: 'rgba(231, 178, 88, 1)',
          pointBackgroundColor: 'rgba(231, 178, 88, 1)',
          pointBorderColor: '#fff',
          data: self.currencyData,
          fill:false
        },
        {
          label: 'Power',
          backgroundColor: 'rgba(136, 125, 88, 0.2)',
          borderColor: 'rgb(136, 125, 88, 1)',
          pointBackgroundColor: 'rgb(136, 125, 88, 1)',
          pointBorderColor: '#fff',
          data: self.powerData,
          fill:false
        },
        {
          label: 'Tension',
          backgroundColor: 'rgba(119, 80, 99, 0.2)',
          borderColor: 'rgb(119, 80, 99, 1)',
          pointBackgroundColor: 'rgb(119, 80, 99, 1)',
          pointBorderColor: '#fff',
          data: self.tensionData,
          fill:false
        }
      ]

    },

    sendToUpdate(forModal = false) {
      this.$nextTick(() => {
        this.$refs.powerCurveView.scrollTop = 0;
      });

      if(!forModal)
        this.newItem = false;

      let self = this
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/projects/' + this.selected, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('sendToUpdate', response)
        if(forModal) {
          self.modalProps['modalName'] = response.data.data.name;
        } else if (!forModal) {
          self.projectName = response.data.data.name;
          self.time_weeks = response.data.data.time_weeks;
          self.currency = response.data.data.currency;

          self.max = response.data.data.impedance * 2;
          let sliderVal = response.data.data.impedance
          self.slider = sliderVal.split('.')[0]
          self.showSlider = true
          console.log('slider', self.slider);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    updatePowerCurve() {
      let self = this;
      const postData = {
        name: self.projectName,
        time_weeks: self.time_weeks,
        impedance: self.slider,
        currency: self.currency
      };
      const token = localStorage.getItem("api_token")
      axios.put(this.$apiAdress + '/api/projects/' + this.selected, postData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      });

      this.alertPlaceholder = this.projectName;
      this.updateSuccess = true;
      this.resetForm();

      setTimeout(function () {
        this.updateSuccess = !this.updateSuccess
      }.bind(this), 5000);
      this.forceRerender()
    },

    deletePowerCurve() {
      let self = this
      const token = localStorage.getItem("api_token")
      axios.delete(this.$apiAdress + '/api/projects/' + this.selected, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
        // self.$router.push({ path: 'dashboard' });
      }).catch(function (error) {
        console.log(error)
        // self.reset()
      });

      this.alertPlaceholder = this.projectName;
      this.deleteSuccess = true;

      setTimeout(function () {
        this.deleteSuccess = !this.deleteSuccess
      }.bind(this), 5000);
      this.forceRerender()
      self.modalProps['showModal'] = false;
    },

    forceRerender() {
      console.log(this.advancedTableKey + "====")
      this.advancedTableKey += 1;
      console.log(this.advancedTableKey + "====")
      this.getData()
    }
  }
}
</script>

<style lang="scss">

/* Set the theme color of the component */
// $themeColor: #008000;
// $bgColor: #008000;
// $stepColor: #008000;
// $stepBgColor: #008000; 

/* import theme style */
@import '~vue-slider-component/lib/theme/antd.scss'; 

.vue-slider-rail {
  height: 200% !important;
}

.vue-slider-mark-label {
    font-size: 14px !important;
}

// .vue-slider-mark-step .vue-slider-mark-step-active {
//   box-shadow: #000000 !important;
//   background-color: #800000 !important;
// }

// .vue-slider-dot .vue-slider-dot-hover {
//   box-shadow: #000000 !important;
//   background-color: #800000 !important;
// }

// .vue-slider-dot-tooltip-inner {
//   font-size: 14px;
//   white-space: nowrap;
//   padding: 2px 5px;
//   min-width: 20px;
//   text-align: center;
//   color: rgb(0, 0, 0);
//   border-radius: 5px;
//   border-color: #FBF6F7!important;
//   background-color: #FBF6F7!important;
//   box-sizing: content-box;
// }

// .vue-slider-mark-step {
//   display: block!important;
//   width:15px;
//   height:15px;
//   border-radius:50%;
//   background:green;
//   transform: translate(-50%, -50%);
// }

// .vue-slider-dot {
//   display: block!important;
//   border-radius:50%;
//   background:green;
//   transform: translate(-50%, -50%);
// }
.chartjs-render-monitor {
  height: 400px !important;
}

</style>

<style scoped>
/* .category-form {
   margin: 0 25%;
   width: 50%;
} */

.custom-class {
  width: 95% !important;
}

.container {
  grid-template-columns: 20% auto 10% 10%;
  grid-template-rows: 100%
}

.update-btn {
  margin-left: -30%;
}

.center-item {
  grid-column-start: 2;
  grid-column-end: 3;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fixed {
  position: fixed;
  width: 20%;
  bottom: 10px;
  z-index: 1;
  right: 2%;
}

.top-fixed {
  position: fixed;
  width: 45%;
  top: 10px;
  z-index: 2;
}

/*.impedanceButton {*/
/*  width: 10%;*/
/*}*/

</style>
